'use client';

import ArticlePagination from '@/components/articlePagination/ArticlePagination';
import HeadlineField from '@/components/customFields/HeadlineField';
import { type GenericBlok, HeadlineTag } from '@/components/customFields/types';
import MagazineTrendCards from '@/components/magazineTrendCards/MagazineTrendCards';
import type { PillCardProps } from '@/components/pillCard/PillCard';
import Stage from '@/components/stage/Stage';
import { getStageTextForPaginatedPage } from '@/helper/paginationUtils';
import { useMagazineTrendCardsProvider } from '@/providers/MagazineTrendCardsProvider/MagazineTrendCardsProvider';
import classes from '@/storyblok/PageMagCategory/PageMagCategory.module.scss';
import type { PageMagCategoryStoryblok } from '@/types/component-types-sb';
import type { ISbStoryData } from '@storyblok/react/rsc';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export type PageMagCategoryProps = {
  articles: PillCardProps[];
  page: number;
  pages: number;
  breadcrumbs: ISbStoryData<GenericBlok>[];
  slug: string;
  story: ISbStoryData<PageMagCategoryStoryblok>;
  blok?: PageMagCategoryStoryblok | undefined;
  relatedPressArticles?: PillCardProps[];
};

export const ITEMS_PER_PAGE = 6;

export const PageMagCategory: React.FC<PageMagCategoryProps> = (props) => {
  const { t } = useTranslation();
  const trendArticles = useMagazineTrendCardsProvider();

  let title = props.blok?.name;
  if (props.page > 1) {
    title += ` / ${t('pagination.page')} ${props.page}`;
  }

  const content = props.page === 1 ? getStageTextForPaginatedPage(props.blok?.description, props.page) : '';
  return (
    <div data-testid="pagmagcategory" className={classNames(classes.magazineAuthor)}>
      <Stage
        prefix={t('magazineCategory.subTitle')}
        content={content}
        title={title}
        media={props.blok?.image}
        imageAltTag={props.blok?.imageAltTag}
        type={props.page > 1 ? 'mini' : 'default'}
        breadcrumbs={props.breadcrumbs}
      />
      <div className="grid-wrapper">
        {props.page === 1 && trendArticles && trendArticles.length > 0 && (
          <section className={classes.trendCards}>
            <HeadlineField className={classes.SectionTitle} tag={HeadlineTag.H2} style={HeadlineTag.H3}>
              {t('magazine.trendTopics')}
            </HeadlineField>
            <MagazineTrendCards trendArticles={trendArticles} />
          </section>
        )}
        <div className="content-bloks-wrapper">
          <section>
            <HeadlineField className={classes.SectionTitle} tag={HeadlineTag.H2} style={HeadlineTag.H3}>
              {t('magazine.lastPosts')}
            </HeadlineField>
            <ArticlePagination articles={props.articles} baseUrl={props.slug} page={props.page} count={props.pages} />
          </section>
        </div>
      </div>
    </div>
  );
};
export default PageMagCategory;
